<div class="kl-detail-filter-shell" [class.kl-detail-filter-shell--no-right]="!showRight()">
  @if (alertShow()) {
    <kl-alert
      class="kl-detail-filter-shell__alert"
      [show]="true"
      [message]="alertMessage()"
      type="error"
      [showClose]="true"
      (onClose)="alertClose.emit()" />
  }
  @if (loading()) {
    <div class="kl-detail-filter-shell__loading d-flex align-items-center justify-content-center">
      <kl-loader />
    </div>
  } @else {
    <div class="kl-detail-filter-shell__toolbar">
      <div class="kl-detail-filter-shell__toolbar-start">
        <p-button
          type="button"
          size="small"
          [label]="applyLabelKey() | translate"
          icon="ph ph-check"
          [loading]="applyBusy()"
          (onClick)="onApply()" />
        <p-button
          type="button"
          size="small"
          [label]="clearLabelKey() | translate"
          icon="ph ph-minus-circle"
          severity="secondary"
          (onClick)="onClear()" />
        <p-button
          type="button"
          size="small"
          [label]="closeLabelKey() | translate"
          icon="ph ph-x"
          severity="secondary"
          [outlined]="true"
          (onClick)="onClose()" />
      </div>
      <div class="kl-detail-filter-shell__toolbar-center">{{ middleTitleKey() | translate }}</div>
      @if (showRight()) {
        <div class="kl-detail-filter-shell__toolbar-end">{{ rightTitleKey() | translate }}</div>
      }
    </div>

    <div class="kl-detail-filter-shell__columns">
      <aside class="kl-detail-filter-shell__col kl-detail-filter-shell__col--left">
        <ng-content select="[klDetailFilterLeft]" />
      </aside>
      <section class="kl-detail-filter-shell__col kl-detail-filter-shell__col--middle">
        <ng-content select="[klDetailFilterMiddle]" />
      </section>
      @if (showRight()) {
        <aside class="kl-detail-filter-shell__col kl-detail-filter-shell__col--right">
          <ng-content select="[klDetailFilterRight]" />
        </aside>
      }
    </div>
  }
</div>
